<section>
  <app-datatable
    [columns]="columns"
    [dataUrl]="dataUrl"
    [defaultSort]="defaultSort"
    [scrollV]="false"
    [scrollH]="true"
    [preventInitialLoad]="true"
    [disableFiltering]="false"
    data-automation-id="active-prior-auth-list-provider_202127112109"
    emptyMessage="There are no active Prior Authorization Requests."
    [multiSelect]="false"
    [rowClass]="getRowClass"
    [exportFileName]="'Active Prior Auth Queue'"
  ></app-datatable>

  <ng-template #idTemplate let-row="row" let-value="value">
    <a
      class="mat-button-link"
      data-automation-id="active-prior-auth-list-provider_202127112112"
      tabindex="0"
      [routerLink]="[AppUrls.priorAuthorization.details(row.priorAuthorizationId)]"
    >
      <span class="visually-hidden">Navigate to Prior Auth</span>
      {{ value | entityFormatter: priorAuthTypeCode }}
    </a>
  </ng-template>

  <ng-template #injuryDateTemplate let-row="row" let-value="value">
    {{ row.dateOfInjuryDisplay }}
  </ng-template>
</section>
